<template>
  <div>
    <!-- 交易查询结果 -->
    <el-dialog title="hash查询结果" :visible.sync="hahsDialogVisible" width="70%">
      <json-view :data="returnHash" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="hahsDialogVisible = false">{{ $t('title.Cancel') }}</el-button>
        <el-button type="primary" @click="hahsDialogVisible = false">{{ $t('title.Sure') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import jsonView from "../json-view";
import { getTransactionByHash } from "../../api/interface";
export default {
  components: { jsonView },
  data() {
    return {
      hahsDialogVisible: false,
      returnHash: {}
    };
  },
  methods: {
    async open(hash, rpcServer, chainId, optionRpc) {
      let serverUrl = ""
      optionRpc.forEach(item => {
        let rpcObj = JSON.parse(item.description)
        if(rpcObj){
          Reflect.ownKeys(rpcObj).forEach((key)=>{
            if(rpcObj[key] == rpcServer){
                serverUrl = item.browserUrl
            }
          })
        }
      });
      this.returnHash = []
      this.hahsDialogVisible = true;
      const data = {
        hash,
        chainId,
        rpcServer,
        serverUrl
      };
      getTransactionByHash(data, 2)
        .then(res => {
          if(res.code == 200){
            this.isResponse = false;
            this.returnHash = res.data;
            this.$message.success(res.msg)
          }else{
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          this.isResponse = false;
          this.returnHash = err.data;
          this.$message.error(err.msg)
        })
    }
  }
};
</script>